import { post, get } from './handler'
import { appendPathWithSlash, removePathWithSlash } from '../libs/common'
import { departmentColors, destinationColors } from '../libs/theme'

console.log('backend domain is:', process.env.REACT_APP_BE_DOMAIN)
console.log('firebase domain is:', process.env.REACT_APP_FIREBASE_AUTH_DOMAIN)

const coreApiUrl = process.env.REACT_APP_BE_DOMAIN
const opsApiUrl = process.env.REACT_APP_BE_DJANGO_DOMAIN

const buildFlexQuery = (params = {}, appendToPath = '') => {
  const items = Object.keys(params).map((key) => {
    const data = params[key]
    if (Array.isArray(data) && data.length) {
      return key + '=' + data.join()
    } else {
      return key + '=' + data
    }
  })
  let query = ''
  if (items.length) {
    query = '?'
    items.forEach((item, index) => {
      if (item) {
        query += (index > 0 ? '&' : '') + item
      }
    })
  }

  if (appendToPath) {
    // enforces url is conforming to DRF REST principless so that a 301 redirect is not triggered
    return appendPathWithSlash(appendToPath) + query
  }
  return query
}
export const core = {
  getTable: (table) => get(coreApiUrl + `/table/${table}`),
  getFlow: (path) => get(coreApiUrl + `${path}`)
}
export const appSheet = {
  getTable: (table) =>
    get(coreApiUrl + '/appsheet/table/' + table + '/action', { tkType: 'cookieOnly' }),
  postAction: (table, data) =>
    post(coreApiUrl + '/appsheet/table/' + table + '/action', data, { tkType: 'cookieOnly' }),
  postBatchAction: (table, data) =>
    post(coreApiUrl + '/appsheet/table/' + table + '/batchAction', data, { tkType: 'cookieOnly' })
}

export const opsAPI = {
  getFromMarketplace: (path, params, options) =>
    get(opsApiUrl + '/api/mkt/' + buildFlexQuery(params, path), options),
  getFromRetail: (path, params, options) =>
    get(opsApiUrl + '/api/retail/' + buildFlexQuery(params, path), options),
  postToRetail: (path, data) => post(opsApiUrl + '/api/retail/' + path, data),
  get: (path, params, options) => get(opsApiUrl + '/api/' + buildFlexQuery(params, path), options),
  getFullPath: (path, options) => get(path, options),
  getOpsFullPath: (path, params, options) => get(opsApiUrl + path + buildFlexQuery(params), options)
}
// copied from db for now, these don't change much so avoid the api calls
export const destinations = [
  {
    id: 1,
    name: 'Charity',
    colour: destinationColors.charity,
    colourOrder: 1
  },
  {
    id: 3,
    name: 'Compost',
    colour: destinationColors.compost,
    colourOrder: 2
  },
  {
    id: 2,
    name: 'Farm',
    colour: destinationColors.farm,
    colourOrder: 3
  }
]
export const getDestinationForId = (id) => destinations.find((i) => i.id === parseInt(id)).name
// department colour order is set based on Analgous colors.
// Analogous colors are adjacent to or near each other on the color wheel. Together,
// they look aesthetically pleasing and produce a calming effect, as opposed to the intensity of complementary colors.
export const departments = [
  {
    id: 1,
    name: 'Bakery',
    colour: departmentColors.bakery,
    colourOrder: 5
  },
  {
    id: 2,
    name: 'Dairy',
    colour: departmentColors.dairy,
    colourOrder: 1
  },
  {
    id: 3,
    name: 'Deli',
    colour: departmentColors.deli,
    colourOrder: 4
  },
  {
    id: 4,
    name: 'Meat/Seafood',
    colour: departmentColors['meat/seafood'],
    colourOrder: 2
  },
  {
    id: 5,
    name: 'Produce',
    colour: departmentColors.produce,
    colourOrder: 6
  },
  {
    id: 6,
    name: 'Grocery',
    colour: departmentColors.grocery,
    colourOrder: 3
  },
  {
    id: 7,
    name: 'Other',
    colour: departmentColors.other,
    colourOrder: 0
  }
]
export const getDepartmentForId = (id) => departments.find((i) => i.id === parseInt(id)).name
// dont want to break anything in reporting
export const getDepartmentForIdV2 = (id) =>
  id ? departments.find((i) => i.id === parseInt(id)).name : 'N/A'
export const sortByColourOrder = (a, b) => {
  // this will sort department by the colourOrder key value
  let oA = a.colourOrder
  let oB = b.colourOrder
  if (oA < oB) {
    return -1
  } else if (oA > oB) {
    return 1
  }
  return 0
}

export const buildNameToColorMapping = () => {
  const colorMapping = { departments: {}, destinations: {} }
  departments.forEach((dept, index) => (colorMapping.departments[dept.name] = dept.colour))
  destinations.forEach((dest, index) => (colorMapping.destinations[dest.name] = dest.colour))
  return colorMapping
}
